// extracted by mini-css-extract-plugin
module.exports = {"main":"Spinner_main__1Fu2b","spinner":"Spinner_spinner__2WNAf","spin":"Spinner_spin__1CvXt"};